// Product UI hierarchy. Marketing, story artwork and printed-book typography
// own their display styles; form dialogs keep their compact field-label sizes.
export const productPageTitleSx = {
  color: '#FFFFFF',
  fontSize: { xs: 24, sm: 28, md: 32 },
  fontWeight: 900,
  lineHeight: 1.1,
  letterSpacing: '-0.02em',
} as const;

// Fixed dashboard chrome stays compact above the 20px product section titles.
export const productHeaderTitleSx = {
  ...productPageTitleSx,
  fontSize: { xs: 22, sm: 24 },
  fontWeight: 800,
  lineHeight: 1.2,
} as const;

export const productSectionTitleSx = {
  color: '#FFFFFF',
  fontSize: 20,
  fontWeight: 750,
  lineHeight: 1.35,
  letterSpacing: '-0.03em',
  textAlign: 'left',
} as const;

export const productCardTitleSx = {
  color: '#FFFFFF',
  fontSize: 18,
  fontWeight: 750,
  lineHeight: 1.35,
  letterSpacing: '-0.02em',
} as const;

export const productSupportingTextSx = {
  color: '#B9BAC5',
  fontSize: 16,
  fontWeight: 400,
  lineHeight: 1.6,
} as const;

// Billing cards are also used on public pages. Scope account typography to the
// signed-in screen so marketing headings and artwork keep their existing scale.
export const accountBillingTypographySx = {
  '& .billing-hero h1, & .billing-section-heading h2, & .membership-plan-heading h2': productSectionTitleSx,
  '& .membership-current-copy h2, & .membership-balance h2, & .billing-bottom-note h2, & .membership-benefits-header-copy h3': productCardTitleSx,
  '& .billing-hero > p, & .billing-section-heading p, & .membership-plan-heading p, & .membership-balance-heading > p, & .billing-bottom-note p, & .membership-benefits-header-description': productSupportingTextSx,
} as const;
